var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconPoweredByHearXGroup } from 'hx-assets';
export var Footer = function () { return (_jsx("div", __assign({ className: "grid w-full place-items-center" }, { children: _jsx(IconPoweredByHearXGroup, { className: "flex md:hidden", width: "130px" }) }))); };
